export default class FreitextValidator {
    static isAnswerCorrect(answer) {
        const selfRating    = answer.userInput().find( x => x.key==='selfRating')
        const noInput       = !selfRating || !selfRating.value

        return noInput ? false : (selfRating.value.bewertung === 'richtig')
    }
}